import { ProductType } from '~/techstyle-shared/react-products';

export function isPreorderAvailable(product) {
  if (!product) {
    return false;
  }
  const { productTypeId } = product;

  // outfit not sized 'availableQuantityPreorderAnyProfile';
  // item not sized availableQuantityPreorderMaster';
  // outfit sized = profileAvailableQuantity';
  // item sized = 'availableQuantityPreorder';
  // Will return Preorder available if one of the objects in the list have preorder available
  switch (productTypeId) {
    case ProductType.BUNDLE: {
      // if sized, return true if one of the sized bundles has preorders
      // TODO: Currently, productOptionProfileIdObjectList doesn't return sized preorder quantities. CF is working on a ticket.
      // Defaults to no preorder available if it's sized due to the above comment.
      const preorderByAvailableQuantityPreorder =
        product.productOptionProfileIdObjectList
          ? false
          : product.availableQuantityPreorderAnyProfile;
      const preorderByBundleComponentProducts =
        product.bundleComponentProducts?.some((bundleProduct) =>
          isPreorderAvailable(bundleProduct)
        );
      return (
        preorderByAvailableQuantityPreorder || preorderByBundleComponentProducts
      );
    }
    default: {
      // IndividualProduct type from gql has 'skus' field, so we can derive preorder status from there
      if (product.skus) {
        const availableForPreorder = product.skus.some(
          (skuItem) => skuItem.isPreorder
        );
        return availableForPreorder;
      }
      // Assume the product is normal type otherwise
      return product.productIdObjectList
        ? product.productIdObjectList.some(
            (sizedProd) => sizedProd.availableQuantityPreorder > 0
          )
        : product.availableQuantityPreorderMaster > 0;
    }
  }
}
